var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"db-3 screen"},[_c('div',{staticClass:"body-wrapper"},[_c('billing-component')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }